import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const SPECS = {
  ...SdkSpecs,
  SUBSCRIPTION_PLAN_USE_TPA_RADIO_BUTTON: 'specs.stores.SubscriptionPlanUseTpaRadioButton',
  USE_LIGHTBOXES: 'specs.stores.UseLightboxes',
  EDITOR_OOI: 'specs.stores.EditorGalleryOOI',
  DISABLE_MOBILE_NATIVE_DROPDOWN: 'specs.stores.DisableMobileNativeDropdown',
  FIX_CASHIER_PROPS_PRICE_SHIFTING: 'specs.stores.ProductPageFixCashierPropsPriceShifting',
  LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE:
    'specs.stores.ProductPageLocationOnChangePathChangeForEditorSausage',
  PRODUCT_PAGE_MIGRATE_TO_RICO_DESCRIPTION: 'specs.stores.ProductPageMigrateToRicoDescription',
  PRODUCT_PAGE_SLOTS: 'specs.stores.ProductPageSlots',
  PRODUCT_PAGE_NEW_WIX_CODE_API: 'specs.stores.ProductPageNewWixCodeApi',
  EnableDynamicSizeDefaultImage: 'specs.stores.EnableDynamicSizeDefaultImage',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  MainMediaWrapperAsAnchorElement: 'specs.stores.MainMediaWrapperAsAnchorElement',
  ProductPageSlotsAddMoreProps: 'specs.stores.ProductPageSlotsAddMoreProps',
  ProductPageUpliftProductOptionsViewer: 'specs.stores.ProductPageUpliftProductOptionsViewer',
  SubscriptionPlansNewDesignViewer: 'specs.stores.SubscriptionPlansNewDesignViewer',
  ProductPageSupportGridLayout: 'specs.stores.ProductPageSupportGridLayout',
  InfoSectionTabsTPAComponent: 'specs.stores.InfoSectionTabsTPAComponent',
  LoadClientConfigInController: 'specs.stores.LoadClientConfigInController',
  AllowProductPageButtonsOption: 'specs.stores.allowProductPageButtonsOption',
  ProductPageSsrInvalidationTags: 'specs.stores.ProductPageSsrInvalidationTags',
  ProductMediaNavigationDots: 'specs.stores.ProductMediaNavigationDots',
  ProductPageFixReflowSausageNavigation: 'specs.stores.ProductPageFixReflowSausageNavigation',
  MediaSlotOnBottomForResponsiveGallery: 'specs.stores.ResponsiveLayoutMediaSlotBottom',
  ProductPageConsumePublicDataFromBothScopes: 'specs.stores.ProductPageConsumePublicDataFromBothScopes',
  FixVariantIdCalculationInBuyNowFlow: 'specs.stores.FixVariantIdCalculationInBuyNowFlow',
  UseExperimentsFromPlatformFlowApi: 'specs.stores.UseExperimentsFromPlatformFlowApi',
  ProductPageRemovePagination: 'specs.stores.ProductPageRemovePagination',
  ProductNameHtmlTag: 'specs.stores.ProductNameHtmlTag',
  ResponsiveEditorBreadcrumbsToggle: 'specs.stores.ResponsiveEditorBreadcrumbsToggle',
  ProductPageVideoPosterOptimization: 'specs.stores.ProductPageVideoPosterOptimization',
  StickyAddToCartMobile: 'specs.stores.StickyAddToCartMobile',
  FixProductPageDropdownMobileSsr: 'specs.stores.FixProductPageDropdownMobileSsr',
  ProductPageBreadcrumbsDesignViewer: 'specs.stores.ProductPageBreadcrumbsDesignViewer',
  CheckoutPagePreviewEnabled: 'specs.stores.CheckoutPagePreviewEnabled',
  AddDiscountsToVariantsItemsQueries: 'specs.stores.AddDiscountsToVariantsItemsQueries',
  ShowUserWishlistStateInProductPage: 'specs.stores.ShowUserWishlistStateInProductPage',
  CombinedListing: 'specs.stores.CombinedListing',
  CustomTextDesignViewer: 'specs.stores.CustomTextDesignViewer',
  ProductPageWishlistTrackEvent: 'specs.stores.ProductPageWishlistTrackEvent',
  ProductPageDescriptionToggle: 'specs.stores.ProductPageDescriptionToggle',
  UseCartV2ForDirectPurchase: 'specs.stores.UseCartV2ForDirectPurchase',
  OnlineStoresCurrencyClientFormatting: 'specs.stores.OnlineStoresCurrencyClientFormatting',
  FixProductPageHydrationError: 'specs.stores.FixProductPageHydrationError',
  UseGetClientConfigFromPublicApi: 'specs.stores.UseGetClientConfigFromPublicApi',
  ProductPageMainMediaNavigationArrows: 'specs.stores.ProductPageMainMediaNavigationArrows',
  ShowMultiRibbonsInProductPage: 'specs.stores.ShowMultiRibbonsInProductPage',
  MoveCustomUrlApiToSiteStoreConstructor: 'specs.stores.MoveCustomUrlApiToSiteStoreConstructor',
  ZoomableMainMedia: 'specs.stores.ZoomableMainMedia',
  FixProductPageMediaCentering: 'specs.stores.FixProductPageMediaCentering',
  FixPPTotalSwiperSizeCalc: 'specs.stores.FixPPTotalSwiperSizeCalc',
  FixPPMainImageOverflow: 'specs.stores.FixPPMainImageOverflow',
  FixNavigationDotsPosition: 'specs.stores.FixNavigationDotsPosition',
  FixProductPageDescriptionReadMore: 'specs.stores.FixProductPageDescriptionReadMore',
  ShowFromTextOnFullSelectedVariant: 'specs.stores.ShowFromTextOnFullSelectedVariant',
  StorefrontSwatchImages: 'specs.stores.StorefrontSwatchImages',
  FixPreviewCustomProductUrlSlug: 'specs.stores.FixPreviewCustomProductUrlSlug',
  FixPPAddToCartButtonTextKeyPriority: 'specs.stores.FixPPAddToCartButtonTextKeyPriority',
};
